import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "laSexta",
  "use": "laSexta-usage",
  "viewBox": "0 0 20 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 23\" id=\"laSexta\"><title>La Sexta</title><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#1E8737\" d=\"M0 14.48L4.918 23l3.432-5.943-1.484-2.57 1.486-2.572h.003L4.918 5.962z\" /><path fill=\"#1EAF37\" d=\"M12.804 14.48l.004.007-1.486 2.573h-2.97l-.002-.003L4.918 23h9.837l4.92-8.52z\" /><path fill=\"#1ED732\" d=\"M8.36 0L4.92 5.962l3.436 5.953h2.967l1.482 2.566h6.87l-4.918-8.52h-2.954L15.244 0z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol